export enum Admingroup {
  GROUP_MARKETING = 'Admin',
  GROUP_KSC = 'Kundenservice',
  GROUP_SALES = 'Vertrieb'
}
